@import (reference) '../../../../../../constants/spacing.module.less';

.container {
  padding: @space-16;
}

.section-title {
  margin-bottom: @space-16;
}

.details-grid {
  min-height: 80px;
  flex-wrap: wrap;
}

.details-column {
  flex: 1;
  min-width: 200px;
  margin-bottom: @space-16;
  margin-right: @space-32;

  &:last-child {
    margin-right: 0;
  }
}

.divider {
  border-color: var(--gray-DFE4E8);
}
